const assertIsNever = (value: never): never => {
    throw new Error(`Expected ${value} to be never`);
};

export default assertIsNever;
